export default (previousState={}, {type, payload}) => {
	if (type && type === 'AUTH_RECEIVED') {
		return payload.data
	}
	return previousState
};